import React, { useState,useEffect,useCallback } from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import { BASE_URL } from '../Config/Base'
import { ToastContainer,toast } from 'react-toastify'
import _ from 'lodash';


const pageSize = 5;

const ParoCausesMain = () => {
  const [fileA, setFileA] = useState();
  const [fileB, setFileB] = useState();
        // console.log(file)
      
 const handleFileChange1 = (e) => {

          setFileB(e.target.files[0]);
             
          setFileA(e.target.value)
      
          document.getElementById("Parochangeinput").reset()
        };




        const [EditParoDate ,SetEditParoDate ] =useState();
 const handleDateChange =(e) =>{

  SetEditParoDate(e.target.value)
  console.log(EditParoDate)
 }



  const [allusers,setAllusers]= useState([])

  
  const [paginatedPosts, setpaginatedPosts] = useState();
  //const [currentPage, setcurrentPage] = useState(1);

  useEffect(()=>{


    if(transdata==null){

      document.getElementById('data').innerHTML = "NO DATA"
      
       }
      
     else{
      
      document.getElementById('data').innerHTML = " "
      
     }
      
    getparosection();
    getRoleData();
    getParouserRole();
    // document.getElementById('Paro-pag').style.display = "none"
    // setTimeout(() => {
      // document.getElementById('Paro-pag').style.display = "flex" 
     
    // }, 3000);

   },[])



   /**** Section view task****/

  function getRoleData(){
    let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));
    
   let UserRole =  localStorage.getItem("Role");
  
   const body ={
    
    role:UserRole
  
   }
   console.log(body);
  
  
    axios({          
       method: "POST", 
       url: `${BASE_URL}/Paropakari/GetParoLoginUserRole`,      
      //  url: "https://localhost:44312/Api/Tc/GetTcloginUserRole",
       data:body,
       headers: {             
         'Content-Type': 'application/json' , 
         'Authorization':bearer     
       }
     
     })
     .then((response) =>{
      console.log(response.data);
      localStorage.setItem("loginUserRoleaction", JSON.stringify(response.data));
      
       }) 
     
      }



      function getParouserRole(){
    
        let Corprole =  localStorage.getItem("loginUserRoleaction");
        let roledata =  JSON.parse(Corprole);
        let role = roledata.map((e)=>e.userroleaction);
        console.log(role);
        localStorage.setItem("ROLE",role)
      
        let roles = role.toString();
        let roleResult = roles.includes('Add')
        console.log(roleResult)
        localStorage.setItem("add",roleResult)

        let roleResultA = roles.includes('View')
        console.log(roleResultA)
        localStorage.setItem("View",roleResultA)
        
        let roleResultB = roles.includes('Edit')
        console.log(roleResultB)
        localStorage.setItem("Edit",roleResultB)
        
        let roleResultC = roles.includes('Delete')
        console.log(roleResultC)
        localStorage.setItem("Delete",roleResultC)

     
        let empty = roles.includes('')
        console.log(empty)

       let roleid = localStorage.getItem('RoleId')
       let id = roleid.includes('01')
       console.log(id)

        /*---- Show delete----*/ 

        if(id==true&&empty==true&&roleResult==false&&roleResultA==false&&roleResultB==false&&roleResultC==false)
        {
         setCorpdisplay(true);
         setCorpEditdisplay(true);
         setCorpDeletedisplay(true);
        
        }
        if(id==false&&empty==true&&roleResult==false&&roleResultA==false&&roleResultB==false&&roleResultC==false)
        {
         setCorpdisplay(false);
         setCorpEditdisplay(false);
         setCorpDeletedisplay(false);
          document.getElementById('parocausetable').style.display ="none";
          document.getElementById('Paropagi').style.display ="none";
          document.getElementById('Paroaction-err').innerHTML = 'Not Assign'
          document.getElementById('Paroaction-err').style.color = "red"
          document.getElementById('Paroaction-err').style.fontWeight = "bold"
          document.getElementById('Paroaction-err').style.alignItems = "center"
          document.getElementById('Paroaction-err').style. justifyContent = "center"
          document.getElementById('Paroaction-err').style. display= "flex"

         
        }


         /*---- Show delete----*/ 
    

if(roleResult==false&&roleResultA==false&&roleResultB==false&&roleResultC==true){
  setCorpdisplay(true);
  setCorpEditdisplay(false);
  setCorpDeletedisplay(true);
  // document.getElementById('Paro-section-btn').style.display ="none";

}


         /*---- Show add view----*/ 
  
    if(roleResult==true&&roleResultA==true&&roleResultB==false&&roleResultC==false){
      setCorpdisplay(false);
      setCorpEditdisplay(false);
      setCorpDeletedisplay(false);
      // document.getElementById('Paro-section-btn').style.display ="block";
    
    }

 /*---- Show add ----*/ 
    
    if(roleResult==true&&roleResultA==false&&roleResultB==false&&roleResultC==false){
      setCorpdisplay(false);
      setCorpEditdisplay(false);
      setCorpDeletedisplay(false);
      // document.getElementById('Paro-section-btn').style.display ="block";
    
    }

    /*---- Show Edit----*/ 
    
    if(roleResult==false&&roleResultA==true&&roleResultB==false&&roleResultC==false){
      setCorpdisplay(false);
      setCorpEditdisplay(true);
      setCorpDeletedisplay(false);
      // document.getElementById('Paro-section-btn').style.display ="none";
    
    }

    

      /*---- Show view----*/ 
    
      if(roleResult==false&&roleResultA==true&&roleResultB==false&&roleResultC==false){
        setCorpdisplay(false);
        setCorpEditdisplay(false);
        setCorpDeletedisplay(false);
        // document.getElementById('Paro-section-btn').style.display ="none";
      
      }






        
       /*---- Show add edit delete view----*/
  
       if(roleResult==true&&roleResultA==true&&roleResultB==true&&roleResultC==false){
        setCorpdisplay(true);
        setCorpEditdisplay(true);
        setCorpDeletedisplay(false);
        // document.getElementById('Paro-section-btn').style.display ="block";
  
      }
       
        if(roleResult==true&&roleResultA==false&&roleResultB==false&&roleResultC==false){
          
          // document.getElementById('Paro-section-btn').style.display ="block";
        }
  
        if(roleResult==false&&roleResultA==true&&roleResultB==false&&roleResultC==false){
         
          setCorpdisplay(false);
          
        //  document.getElementById('Paro-section-btn').style.display ="none";
       }
  
       if(roleResult==false&&roleResultA==false&&roleResultB==true&&roleResultC==false){
  
        // document.getElementById('Paro-section-btn').style.display ="none";
        setCorpDeletedisplay(false);
        setCorpdisplay(true);
       }
  
       if(roleResult==false&&roleResultA==false&&roleResultB==false&&roleResultC==true){
        // document.getElementById('Paro-section-btn').style.display ="none";
        setCorpEditdisplay(false);
       
       }
  
  
       /*---- Show add edit delete view----*/
  
      if(roleResult==true&&roleResultA==true&&roleResultB==true&&roleResultC==true){
        setCorpdisplay(true);
        setCorpEditdisplay(true);
        setCorpDeletedisplay(true);
        // document.getElementById('Paro-section-btn').style.display ="block";
  
      }
  

  
     
  
       /*---- Show delete and edit view----*/
  
       if(roleResult==true&&roleResultA==true&&roleResultB==false&&roleResultC==true){
        setCorpdisplay(true);
        setCorpEditdisplay(false);
        setCorpDeletedisplay(true);
        // document.getElementById('Paro-section-btn').style.display ="block";
  
      }
  
      
  
      
  
  
      /*---- Show add edit ----*/
  
      if(roleResult==true&&roleResultA==false&&roleResultB==true&&roleResultC==false){
        setCorpdisplay(true);
        setCorpEditdisplay(true);
        setCorpDeletedisplay(false);
        // document.getElementById('Paro-section-btn').style.display ="block";
  
      }
  
   /*---- Show add view----*/ 
  
    if(roleResult==true&&roleResultA==true&&roleResultB==false&&roleResultC==false){
    setCorpdisplay(false);
    setCorpEditdisplay(false);
    setCorpDeletedisplay(false);
    // document.getElementById('Paro-section-btn').style.display ="block";
  
  }
  
  
  /*---- Show edit delete ----*/
  
  if(roleResult==false&&roleResultA==false&&roleResultB==true&&roleResultC==true){
    setCorpdisplay(true);
    setCorpEditdisplay(true);
    setCorpDeletedisplay(true);
    // document.getElementById('Paro-section-btn').style.display ="none";
  
  }
  
  
  /*---- Show edit view----*/
  
  if(roleResult==false&&roleResultA==true&&roleResultB==true&&roleResultC==false){
    setCorpdisplay(true);
    setCorpEditdisplay(true);
    setCorpDeletedisplay(false);
    // document.getElementById('Paro-section-btn').style.display ="none";
  
  }
  
  
  
  
  
  /*---- Show delete view----*/
  
  if(roleResult==false&&roleResultA==true&&roleResultB==false&&roleResultC==true){
    setCorpdisplay(true);
    setCorpEditdisplay(false);
    setCorpDeletedisplay(true);
    // document.getElementById('Paro-section-btn').style.display ="none";
  
  }
  

   /*---- Show add delete----*/
  
   if(roleResult==true&&roleResultA==false&&roleResultB==false&&roleResultC==true){
    setCorpdisplay(true);
    setCorpEditdisplay(false);
    setCorpDeletedisplay(true);
    // document.getElementById('Paro-section-btn').style.display ="block";
  
  }
  
  /*---- Show add edit view----*/
  
  if(roleResult==true&&roleResultA==true&&roleResultB==true&&roleResultC==false){
    setCorpdisplay(true);
    setCorpEditdisplay(true);
    setCorpDeletedisplay(false);
    // document.getElementById('Paro-section-btn').style.display ="block";
  
  }
  
  /*---- Show add delete  view----*/
  
  if(roleResult==true&&roleResultA==true&&roleResultB==false&&roleResultC==true){
    setCorpdisplay(true);
    setCorpEditdisplay(false);
    setCorpDeletedisplay(true);
    // document.getElementById('Paro-section-btn').style.display ="block";
  
  }
  
    
  
  /*---- Show edit delete view----*/
  
  if(roleResult==false&&roleResultA==true&&roleResultB==true&&roleResultC==true){
    setCorpdisplay(true);
    setCorpEditdisplay(true);
    setCorpDeletedisplay(true);
    // document.getElementById('Paro-section-btn').style.display ="none";
  
  }
  
      /*---- Show add edit delete view----*/
  
      if(roleResult==true&&roleResultA==true&&roleResultB==true&&roleResultC==true){
        setCorpdisplay(true);
        setCorpEditdisplay(true);
        setCorpDeletedisplay(true);
        // document.getElementById('Paro-section-btn').style.display ="block";
  
      }
  
    
    }


    const[Corpdisplay, setCorpdisplay] =useState(true);
      const[CorpEditdisplay, setCorpEditdisplay] =useState(true);
      const[CorpDeletedisplay, setCorpDeletedisplay] =useState(true);
          





   
  

/*---GetSection Users----*/

const[abouttable, setAbouttable] =useState([])

        
function getparosection(){
  const token = JSON.parse(localStorage.getItem('usertoken'));

 

  fetch(`https://localhost:44312/api/ParopakariMain/GetParoAllCauses`, {
    method:'GET',

  headers : {

    "Content-type": "application/json",

    "Accept": "application/json",

    "Authorization": "Bearer " +`${token}`,

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  },


})

.then(response => response.json())
.then(data => {
console.log("Section",data)
setAllusers(data)
setpaginatedPosts(_(data).slice(0).take(pageSize).value());
localStorage.setItem("CausesData",JSON.stringify(data))
});
}

// const pageCount = allusers? Math.ceil(allusers.length/pageSize) : 0 ;
//   // if (pageCount === 1)
//   // return null;
  
//   const pages = _.range(1, pageCount+1)
  
//   const pagination =(pageNo)=>{
//   setcurrentPage(pageNo);
//   const startIndex = (pageNo-1) * pageSize;
//   const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
//   setpaginatedPosts(paginatedPost)
//   }


 


// --------------------//


/*----del btn Onclick func----*/

function  ParoSectionDeleteStatus(id){
  const token = JSON.parse(localStorage.getItem('usertoken'));

  
  const body ={
    upload_id: id
 }
  console.log('check',body)
   axios({
  
   method:"POST",
  url:`https://localhost:44312/api/ParopakariMain/DeleteCause`,
  data:body,
  headers: {
  "Content-Type" : "application/json",

  }
 
   })
   .then((response) =>{
   console.log(response.data);
   alert("Deleted Successfully !")
  //  toast.success("Section Deleted Successfully !", {
  //   position: "top-center",
  //   autoClose: 3200,
  //   hideProgressBar: false,
  //   closeOnClick: true,
  //   pauseOnHover: true,
  //   draggable: true,
  //   progress: undefined,
  //   className: 'toast-message'
  //   });
    setTimeout(() => {
      
      getparosection();
    }, 1000);
  

   })
  
    }   


    // --------------------------------//
 
    



 /*----Get select to the particular Id----*/

 function ParoSelectfunction(id,cid){

  const token = JSON.parse(localStorage.getItem('usertoken'));
  SetEditParoDate();
  setFileA();
  setFileB();

  document.getElementById("DisplayEditPop").style.display = "block";

   const body =
    {
      
      upload_id:id,
      category_id:cid
    }
    console.log('body',body);

  
    axios({
           method:"POST",
           url :`https://localhost:44312/api/ParopakariMain/ParoSelectCause`,
           data:body, 
           headers: {
                "Content-type": "application/json",
                "Authorization": "Bearer " +`${token}` 
            }     
        }) 
        
   
        .then((response) =>{
          console.log(response.data);
     
     
          SetEditParoSection(response.data);

          localStorage.setItem("SetParoLink", JSON.stringify(response.data));
          let checkLink=JSON.parse(localStorage.getItem('SetParoLink'));
          let Check =checkLink.map((item) => item.file_name)
          let CheckA = Check[0]
          SetOldLink(CheckA)
              let CheckB= CheckA.slice(41);
              SetEditParoLink(CheckB)
              console.log("srdt",CheckB)
       })
       .catch(error => {
         console.log(error);
         
       })

 }

//  ----------------------------------//



/*------ParoAddsection------*/


function ParoAddsection(){

  
  var input = document.getElementById('Parotext').value; 

  if(!input){
    document.getElementById("AddSecErrA").innerHTML="Title Required";
  }
  else if(input){
    document.getElementById("AddSecErrA").innerHTML=" ";
  }

 
  
  if(input){
 
 
  const body ={
   
    Text: input ,
    Image:fileA,
    ActiveStatus:0,
    DeleteStatus:0

  }
  console.log(body);


    axios({
  
      method: "POST",
  
      url: `${BASE_URL}/Paropakari/ParoAddSection`,
      data:body,
      headers: {
        
        'Content-Type': 'multipart/form-data' ,      
        'Authorization':bearer
      }
    
    })
   
    .then((response) =>{
      console.log(response.data);
      if(response.data.status === "Error"){
   
              toast.error("InCorrect")
            }
        
            else if(response.data.status === "Success"){
        
              toast.success("Section Added Successfully!", {
                position: "top-center",
                autoClose: 3200,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                className: 'toast-message'
                });
                setTimeout(() => {
                  getparosection()
                  closeForm()
                }, 1000);
              }
             
       })


       
       .catch(error => {
      console.log(error);
       alert("Section failed !")       
       })
   
      } 
    }
      


  const [EditParoSection ,SetEditParoSection] =useState([]);
  const [EditParoLink ,SetEditParoLink] =useState([]);
  const [OldLink ,SetOldLink] =useState([]);


  //SetEditParoDate 

  let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));

/*----EditSection----*/

function updateParoSection(Id,inputE){
  // const token = JSON.parse(localStorage.getItem('usertoken'));

  var inputA = document.getElementById('ParotextA').value; 
  var inputB = document.getElementById('ParotextB').value; 
  var inputC = document.getElementById('ParotextC').value; 
  var inputD = document.getElementById('ParotextD').value; 
  // var inputE = document.getElementById('ParotextE').value; 
  var inputF = document.getElementById('ParotextF').value; 
  var OldImage = OldLink; 
  var inputH = document.getElementById('ParotextH').value; 
  var inputI = document.getElementById('ParotextI').value; 




 

    if(!inputA){

      document.getElementById("UpdateSecErrA").innerHTML="Title Required";
     }

     else if(inputA){
      document.getElementById("UpdateSecErrA").innerHTML=" ";

     }

     if(!inputB){

      document.getElementById("UpdateSecErrB").innerHTML="Place Required";
     }

     else if(inputB){
      document.getElementById("UpdateSecErrB").innerHTML=" ";

     }


     if(!inputC){

      document.getElementById("UpdateSecErrC").innerHTML="Amount Required";
     }

     else if(inputC){
      document.getElementById("UpdateSecErrC").innerHTML=" ";

     }


     if(!inputD){

      document.getElementById("UpdateSecErrD").innerHTML="Number Of Beneficiaries Required";
     }

     else if(inputD){
      document.getElementById("UpdateSecErrD").innerHTML=" ";

     }

    //  if(!inputE){

    //   document.getElementById("UpdateSecErrE").innerHTML=" Category Id Required";
    //  }

    //  else if(inputE){
    //   document.getElementById("UpdateSecErrE").innerHTML=" ";

    //  }

     if(!inputF){

      document.getElementById("UpdateSecErrF").innerHTML="Category Name Required";
     }

     else if(inputF){
      document.getElementById("UpdateSecErrF").innerHTML=" ";

     }

    //  if(!fileA){

    //   document.getElementById("UpdateSecErrG").innerHTML="Image Required";
    //  }

    //  else if(fileA){
    //   document.getElementById("UpdateSecErrG").innerHTML=" ";

    //  }

    //  if(!EditParoDate){

    //   document.getElementById("UpdateSecErrH").innerHTML=" Start Date Required";
    //  }

    //   else if(EditParoDate){
    //   document.getElementById("UpdateSecErrH").innerHTML=" ";

    //  }

    //  if(!inputI){

    //   document.getElementById("UpdateSecErrI").innerHTML="End Date Required";
    //  }

    //   else if(inputI){
    //   document.getElementById("UpdateSecErrI").innerHTML=" ";

    //  }

    

    if(inputA&&inputB&&inputC&&inputD&&inputF){



 
  
   const body ={
    
   upload_id:Id,
    upload_title:inputA,
    upload_place: inputB ,
    upload_amount:inputC,
    upload_num_of_beneficiaries:inputD,
    CategoryId:inputE,
    CategoryName:inputF,
    file_name:fileB,
    oldImage:OldImage,
    required_by:EditParoDate,
    oldDate:inputH,
    created_date:inputI,

    // required_by:
}
    console.log(body,"checkupdatecause");


     axios({
   
       method: "POST",
       
       url: `https://localhost:44312/api/ParopakariMain/EditCause`,
       data:body,
       headers: {
         'Content-Type': 'multipart/form-data' ,   
         "Access-Control-Allow-Headers": "Access-Control-Request-Headers ",
         "Access-Control-Allow-Origin" :"*"
        //  "Authorization": "Bearer " +`${token}`  
          
       }
     
     })
    
     .then((response) =>{
       console.log(response.data);
       if(response.data.status === "Error"){
    
               toast.error("InCorrect")
             }
         
             else if(response.data.status === "Success"){
         alert("Updated Successfully!")

         setFileA()
         setFileB()
         SetEditParoDate();
         document.getElementById('DisplayEditPop').style.display = "none";
        
             
                 setTimeout(() => {
                  getparosection()
                   closeForm()
                 }, 2000);
               }
              
        })

      .catch(error => {
       console.log(error);
        alert("Failed to Update !")       
        })
     }
    }


 /*----Open & Close Edit and Add popup----*/

 function closeForm(){


 
  document.getElementById('DisplayEditPop').style.display="none";
  document.getElementById('Parosectionform').reset();
  //document.getElementById('ParoEditbotform').reset();


 

 }

 function clodeaddform(){
  document.getElementById('DisplayAddPop').style.display="none";
  document.getElementById('Paroaddsectionform').reset();

  document.getElementById("CauseError").innerHTML = " ";
  document.getElementById("CauseError1").innerHTML = "";
  document.getElementById("CauseError2").innerHTML = "";
  document.getElementById("CauseError3").innerHTML = "";
  document.getElementById("CauseError4").innerHTML = "";
  document.getElementById("CauseError5").innerHTML = "";
  document.getElementById("CauseError6").innerHTML = "";
  document.getElementById("CauseError7").innerHTML = "";
 }

 function openform(){

 document.getElementById('DisplayAddPop').style.display="block";

 }

 const LEFT_PAGE = "LEFT";
 const RIGHT_PAGE = "RIGHT";
 const range = (from, to, step = 1) => {
   let i = from;
   const range = [];
 
   while (i <= to) {
     range.push(i);
     i += step;
   }
 
   return range;
 };
 
 
 const [currentPage, setCurrentPage] = useState(1);
 
 let data = localStorage.getItem("CausesData")
 let transdata =  JSON.parse(data);
 let NUM_OF_RECORDS = transdata.length;
 let LIMIT = 4;
 
 const onPageChanged = useCallback(
 
   (event, page) => {
     event.preventDefault();
     setCurrentPage(page);
   },
   [setCurrentPage]
   
 );
 
 
 const currentData = transdata.slice(
   (currentPage - 1) * LIMIT,
   (currentPage - 1) * LIMIT + LIMIT
 );
 
 const Paginations = (props) => {
   const {
     totalRecords,
     pageLimit,
     pageNeighbours,
     onPageChanged,
     currentPage
   } = props;
   const [totalPages, setTotalPages] = useState(0);
   useEffect(() => {
     setTotalPages(Math.ceil(totalRecords / pageLimit));
   }, [setTotalPages]);
 
   const fetchPageNumbers = () => {
     const totalNumbers = pageNeighbours * 2 + 3;
    
     const totalBlocks = totalNumbers + 2;
    
 
     if (totalPages > totalBlocks) {
       const startPage = Math.max(2, currentPage - pageNeighbours);
       const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
 
       let pages = range(startPage, endPage);
 
       const hasLeftSpill = startPage > 2;
       const hasRightSpill = totalPages - endPage > 1;
       const spillOffset = totalNumbers - (pages.length + 1);
 
       switch (true) {
         case hasLeftSpill && !hasRightSpill: {
           const extraPages = range(startPage - spillOffset, startPage - 1);
           pages = [LEFT_PAGE, ...extraPages, ...pages];
           break;
         }
         case hasLeftSpill && hasRightSpill:
         default: {
           pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
           break;
         }
       }
       return [1, ...pages, totalPages];
     }
     return range(1, totalPages);
   };
 
 
   const pages = fetchPageNumbers() || [];
   return (
     <nav aria-label="Countries Pagination" >
       <ul className="pagination" id='Paro-pag'>
         {pages.map((page, index) => {
           if (page === LEFT_PAGE)
             return (
               <li key={index} className="Paropage-item">
                 <a
                   href="/"
                   className="page-link"
                   aria-label="Previous"
                   onClick={(e) => onPageChanged(e, pageNeighbours * 2 - 1)}
                 >
                   <span aria-hidden="true">&laquo;</span>
                 </a>
               </li>
             );
 
           if (page === RIGHT_PAGE)
             return (
               <li key={index} className="Paropage-item">
                 <a
                   className="page-link"
                   href="/"
                   aria-label="Next"
                   onClick={(e) => onPageChanged(e, pageNeighbours * 2 + 3)}
                 >
                   <span aria-hidden="true">&raquo;</span>
                 </a>
               </li>
             );
 
           return (
             <li
               key={index}
               className={`Paropage-item${currentPage === page ? " active" : ""}`}
             >
               <a
                 className="page-link"
                 href="/"
                 onClick={(e) => onPageChanged(e, page)}
               >
                 {page}
               </a>
             </li>
           );
         })}
       </ul>
     </nav>
   );
 }; 
  // --------------------------------------------\\


  //---- slice function for input img path----//

 

  return (
    <div className='Paro-addmain'>

     {/*  Toastify */ }

     <ToastContainer id="toast"

position="top-center"

autoClose={1500}

hideProgressBar={false}

newestOnTop={false}

closeOnClick

rtl={false}

pauseOnFocusLoss

draggable

pauseOnHover

/>  

<div className="Paro-addgrid-layout">
    <div className="Paro-addmain-top">
        <div className='Paro-addmain-back'>
           <Link to='/ParoSection'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
        </div> 
           <span>Causes</span>
 

     </div>
 </div>

 <span id="Paroaction-err"></span>

<div className='Paro-table'>
        <div class="Paro-table-responsive"  id="parocausetable">
          <span id="data"></span>
          {
            !currentData?(<span style={{display:'flex',justifyContent:'center'}}>No Data Found</span>):(

          <table>
            <thead>
              <tr>
                {/* <th>Id</th> */}
                <th>Title</th>
                <th>Amount</th>
                <th>Number Of Beneficiaries</th>
                <th>Place</th>
                <th>Image</th>
                <th>Start Date</th>
                <th>End Date</th>
                {/* <th>Required For</th> */}
                {/* <th>Category Id</th> */}
                <th>Category</th>
                <th>Required For</th>
                {Corpdisplay?<th>Action</th>:null}


              </tr>
            </thead>
          
          <tbody>

            {currentData.map((e,index)=>
            {
              return<tr key={index}>
                {/* <td>{e.upload_id}</td> */}
                <td>{e.upload_title}</td>
                <td>{e.upload_amount} </td>
              <td>{e.upload_num_of_beneficiaries}</td>
                {/* <span><i class="fa fa-trash" aria-hidden="true" onClick={()=>DeleteSectionA(e.id)} ></i></span> */}
                
              <td>{e.upload_place}</td>
              <td><img src={e.file_name} id="section-image"/></td>
              <td>{e.created_date}</td>
              <td>{e.required_by}</td>
              {/* <td>{e.required_for}</td> */}
              {/* <td>{e.category_id}</td> */}

              <td>{e.category_name}</td>
              <td>{e.required_for}</td>

              {Corpdisplay?<td style={{whiteSpace:"nowrap"}}>
                {CorpEditdisplay?<i class="fa fa-pencil" aria-hidden="true"onClick={()=>ParoSelectfunction(e.upload_id,e.category_id)} id="ParoEdit-icon"></i>:null}&nbsp;&nbsp;
               {CorpDeletedisplay?<i class="fa fa-trash" aria-hidden="true"onClick={()=>ParoSectionDeleteStatus(e.upload_id)} id="ParoDelete-icon"></i>:null}
                </td>:null}

              </tr>
            })}

        </tbody>
        </table>
            )}



<br></br>
 


  
        </div>
        </div>
        {transdata.length<=5? null:<div id="Paropagi">
        {

!paginatedPosts ? (""):(

<Paginations



totalRecords={NUM_OF_RECORDS}

pageLimit={LIMIT}

pageNeighbours={4}

onPageChanged={onPageChanged}

currentPage={currentPage}

/>

)}

</div>
}
     
 
{/* EditPopup */}

<div className='Paropop-fade' id="DisplayEditPop">
{EditParoSection.map((e)=>{
   return<div className="modal-dialog" role="document" id="ParoEditbotform">
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT SECTION</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="Parosectionform" onSubmit={()=>updateParoSection(e.upload_id,e.category_id)}>
      <div className="modal-body mx-3">
     
        <div className="md-form mb-5">
        <label id="ParoSectionTable">Title</label> 
          <input type="text" id="ParotextA"  defaultValue={e.upload_title}/>
          <span id="UpdateSecErrA" className='error'></span>
        </div> 

        <div className="md-form mb-5">
        <label id="ParoSectionTable">Place</label> 
          <input type="text" id="ParotextB"  defaultValue={e.upload_place}/>
          <span id="UpdateSecErrB" className='error'></span>
        </div> 

        <div className="md-form mb-5">
        <label id="ParoSectionTable">Amount</label> 
          <input type="text" id="ParotextC"  defaultValue={e.upload_amount}/>
          <span id="UpdateSecErrC" className='error'></span>
        </div> 

        <div className="md-form mb-5">
        <label id="ParoSectionTable">Number Of Beneficiaries	</label> 
          <input type="text" id="ParotextD"  defaultValue={e.upload_num_of_beneficiaries}/>
          <span id="UpdateSecErrD" className='error'></span>
        </div>


        {/* <div className="md-form mb-5">
        <label id="ParoSectionTable">Category Id</label> 
          <input type="text" id="ParotextE" readOnly defaultValue={e.category_id}/>
          <span id="UpdateSecErrE" className='error'></span>
        </div> */}

        <div className="md-form mb-5">
        <label id="ParoSectionTable">Category Name</label> 
          <input type="text" id="ParotextF"  defaultValue={e.category_name}/>
          <span id="UpdateSecErrF" className='error'></span>
        </div>

      


                          <div className="md-form mb-5">
        <label id="ParoSectionTable">Start Date</label> 
          <input type="text" defaultValue={e.created_date} id="ParotextI" readOnly/>
          <span id="UpdateSecErrI" className='error'></span>
        </div>


                          <div className="md-form mb-5">
        <label id="ParoSectionTable">End Date</label> 
       {!EditParoDate ? <div>
          <input style={{opacity:"0",position:"relative",top:"50px",left:"0px",zIndex:"1",top:"0"}}  type="date" onChange={handleDateChange}/>
          <div style={{border:"1px solid lightgrey" ,height:"42px",borderRadius:"2px",marginTop:"-47px"}}>
            <input defaultValue={e.required_by} id="ParotextH" style={{border:"none",marginLeft:"-1px",background:"transparent",position:"relative"}}/>
 <span><i class="fa fa-calendar-o" aria-hidden="true" id="Parocalender"></i></span>

 </div>

 </div>:
 
 
 <div>
          <input style={{position:"relative",top:"50px",left:"0px",zIndex:"1",top:"0"}}  type="date" onChange={handleDateChange}/>
          <div style={{opacity:"0",border:"1px solid lightgrey" ,height:"42px",borderRadius:"2px",marginTop:"-47px"}}>
            <input defaultValue={e.required_by} id="ParotextH" style={{border:"none",marginLeft:"-1px",background:"transparent",position:"relative"}}/>
 <span ><i class="fa fa-calendar-o" aria-hidden="true" id="Parocalender"></i></span>

 </div>

 </div>
 
 }
          <span id="UpdateSecErrH" className='error'></span>
        </div>

      
        <div className="md-form mb-5">
        <label id="ParoSectionTable">Image</label> 
        {!fileB? <div>
          <input type="file"  style={{opacity:"0",position:"relative",top:"50px",left:"0px",zIndex:"1",top:"0"}} onChange={handleFileChange1} id="ParotextG"/>

<div style={{border:"1px solid lightgrey" ,padding:"1px 12px 1px 12px",borderRadius:"2px",marginTop:"-50px"}}>
<input defaultValue={EditParoLink}  id="oldEventFound"style={{border:"none",marginLeft:"84px",background:"transparent",position:"relative"}}/>
 <span style={{border:"1px solid black",backgroundColor:"#efefef",padding:"2px 2px 2px",borderRadius:"2px",position:"absolute",marginTop:"-38px"}}>Choose File</span>
 {/* &nbsp;<span >{e.fileName}</span> */}
 </div>

</div> 
         
        
        :
<div>
        <form id="Parochangeinput"><input type="file" style={{opacity:"0",position:"relative",top:"50px",left:"0px",zIndex:"1",top:"0"}} onChange={handleFileChange1}/>
        <div style={{border:"1px solid lightgrey" ,padding:"1px 12px 1px",borderRadius:"2px",marginTop:"-50px",color:"red"}}>
        <input defaultValue={fileA}  style={{border:"none",marginLeft:"84px",background:"transparent",position:"relative"}}/>
         <span style={{border:"1px solid black",backgroundColor:"#efefef",padding:"2px 2px 2px",borderRadius:"2px",position:"absolute",marginTop:"-38px"}}>Choose File</span>
      
         </div></form> <input defaultValue={e.file_name} id="oldEventFound" style={{display:"none"}} />
                        
                        </div>
                        }
                          <span id="UpdateSecErrG" className='error'></span>
       
      
     

                          </div>



        </div>
        
        


<div className="modal-footer d-flex justify-content-center">
        <button className='Paro-adduser-button' type="submit">Update</button>
      </div>
      </form>
    </div>
  </div>})}

</div>


    </div>
  )
}

export default ParoCausesMain



